module.exports = __webpack_public_path__ + "static/media/qrold.2d41da78.png";